import React, { useState } from "react";
import { useTransition, animated } from "react-spring";

export const HaveYouReceived = ({ formData, setForm, navigation }) => {
  const { firstName, lastName } = formData;
  const [isVisible, setIsVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(200px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  return (
    <div> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-start mt-24 h-full">
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className="mx-auto"> 
              <h1 className=" text-4xl text-blue-primary font-semibold mb-6 md:mb-10 text-center">
                Have you received a "Notice of Servicing Transfer" letter in the
                mail?
              </h1>
              <div className="py-6 flex flex-col lg:flex-row justify-evenly items-center lg:space-y-0 space-y-8 lg:space-x-12">
                <div>
                  <button
                    onClick={() => navigation.next()}
                    className="hover:bg-blue-dark hover:outline-blue-dark bg-blue-complimentary py-1 px-14 text-white font-semibold text-xl outline-blue-complimentary outline-2 outline outline-offset-6 transition-all w-60 cursor-pointer "
                  >
                    Yes
                  </button>
                </div>
                <div>
                  <button
                    className="hover:bg-blue-dark hover:outline-blue-dark bg-blue-complimentary py-1 px-14 text-white font-semibold text-xl outline-blue-complimentary outline-2 outline outline-offset-6 transition-all w-60 cursor-pointer"
                    onClick={() => navigation.go(2)}
                  >
                    No/Not Sure
                  </button>
                </div>
              </div>
            </animated.div>
          ) : null
        )}
      </div>
    </div>
  );
};
